import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';

const FormObserver = ({ onChange, onValidateChange }) => {
  const formik = useFormikContext();
  const { values, errors } = formik;
  const prevValues = useRef(values);
  const prevErrors = useRef({});

  useEffect(() => {
    if (!onChange) return;
    const changedValues = Object.keys(values).reduce((acc, key) => {
      if (!isEqual(values[key], prevValues.current[key])) {
        acc[key] = values[key];
      }
      return acc;
    }, {});

    if (Object.keys(changedValues).length > 0) {
      onChange(changedValues, values, prevValues.current, formik);
    }

    prevValues.current = values;
  }, [values, onChange]);

  useEffect(() => {
    if (!isEqual(errors, prevErrors.current)) {
      if (onValidateChange) {
        onValidateChange(errors);
      }
      prevErrors.current = errors;
    }
  }, [errors, onValidateChange]);

  return null;
};

export default FormObserver;
